// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZiXy","placeholdersHeader":"styles_placeholdersHeader__18djm","editorStyle":"styles_editorStyle__1BdrI","placeholdersBox":"styles_placeholdersBox__2a8K7"};